import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './ShapesModal.css';

const ShapesModal = ({
  show,
  onHide,
  onShapeSelect,
  title = "Select Shape"
}) => {
  const { t } = useTranslation();
  const [selectedShape, setSelectedShape] = useState(null);

  const shapes = [
    { 
      id: 'circle', 
      name: t('shapeSelection-circle', 'Circle'),
      icon: '⭕',
      description: 'Add a circle shape'
    },
    { 
      id: 'rectangle', 
      name: t('shapeSelection-rectangle', 'Rectangle'),
      icon: '▭',
      description: 'Add a rectangle shape'
    },
    { 
      id: 'triangle', 
      name: t('shapeSelection-triangle', 'Triangle'),
      icon: '△',
      description: 'Add a triangle shape'
    }
  ];

  const handleShapeClick = (shape) => {
    setSelectedShape(shape);
  };

  const handleApply = () => {
    if (selectedShape && onShapeSelect) {
      onShapeSelect(selectedShape.id);
      onHide();
    }
  };

  const handleQuickApply = (shape) => {
    if (onShapeSelect) {
      onShapeSelect(shape.id);
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      className="shapes-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title || t('shapeSelection-shapes', 'Shapes')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="shapes-grid">
          {shapes.map((shape) => (
            <div
              key={shape.id}
              className={`shape-item ${selectedShape?.id === shape.id ? 'selected' : ''}`}
              onClick={() => handleShapeClick(shape)}
              onDoubleClick={() => handleQuickApply(shape)}
              title={shape.description}
            >
              <div className="shape-icon">{shape.icon}</div>
              <div className="shape-name">{shape.name}</div>
            </div>
          ))}
        </div>

        {/* Selected Shape Preview */}
        {selectedShape && (
          <div className="selected-shape-preview mt-3 p-3 bg-light rounded">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="shape-icon-large me-3">{selectedShape.icon}</div>
                <div>
                  <h5 className="mb-1">{selectedShape.name}</h5>
                  <small className="text-muted">{selectedShape.description}</small>
                </div>
              </div>
              <Button variant="primary" onClick={handleApply}>
                {t('shapeSelection-addShape', 'Add Shape')}
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button 
          variant="primary" 
          onClick={handleApply}
          disabled={!selectedShape}
        >
          {t('common.apply', 'Apply')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShapesModal;
